var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompletedTaskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 13 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.371 18.518c-1.51 0-2.317-.793-2.317-2.29V7.921c0-1.497.806-2.297 2.317-2.297h8.258c1.518 0 2.317.8 2.317 2.297v8.305c0 1.498-.8 2.29-2.317 2.29H2.37zm3.404-3.056c.274 0 .506-.137.677-.383l3.186-4.929c.11-.157.184-.341.184-.505 0-.383-.342-.65-.71-.65-.24 0-.445.137-.602.39l-2.762 4.402-1.258-1.586c-.178-.219-.355-.307-.58-.307a.689.689 0 0 0-.691.69c0 .185.068.349.205.52l1.64 1.982c.206.253.431.376.711.376z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedTaskIcon);
export default __webpack_public_path__ + "static/media/completedTaskIcon.1bf7ddb79b0c767f9970d2523515d74d.svg";
export { ForwardRef as ReactComponent };